/**
 * @module events/types/playing
 */

/**
 * @type {string}
 */
export default 'playing'
